import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'lancets', 
  templateUrl: 'lancets.html',
}) 

export class LancetsComponent{

  @Input('minuti') minuti:number; 
  @Input('ore') ore:number; 
  @Input('startcolor') startcolor:string; 
  @Input('endcolor') endcolor:string; 
  min:any;
  hour:any;
  constructor(public events: Events) {
  }
  update_output(){
  //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit(){
    var m = this.minuti*6;
    var h = this.ore*30;
   this.min= "rotate("+m+" 30 30)";
   this.hour= "rotate("+h+" 30 30)";
  }
}



// WEBPACK FOOTER //
// ./src/pages/component/lancets.ts